<div class="filters-container">
  <div class="field-container">
    <div class="icon-container">
      <mat-form-field color="accent" class="field search-field">
        <mat-label>{{sysText.search}}</mat-label>
        <mat-icon matSuffix class="suffix-icon">search</mat-icon>
        <input matInput [formControl]="searchValue" (keyup)="applySearch($event)" #input autocomplete="off"/>
      </mat-form-field>
      <!-- a button so keyboard users can reach the search tips too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="sysText.search_info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="right">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <app-select-field
      class="field"
      [control]="typeControl"
      [label]="sysText.emailType"
      [options]="emailTemplatesData.typeFilterOptions"
      [shouldCapitalize]="false"
      [showBlankOption]="true"
      [showHintArea]="false"
      [hideIconSpace]="true">
    </app-select-field>
    <app-select-field
      class="field"
      [control]="employerControl"
      [label]="sysText.owner"
      [options]="emailTemplatesData.ownerFilterOptions"
      [shouldCapitalize]="false"
      [showBlankOption]="true"
      [showHintArea]="false"
      [hideIconSpace]="true">
    </app-select-field>
  </div>

  <div class="button-container">
    <!-- on mobile this shows only its icon, so its label names it there (a tooltip isn't a name) -->
    <button
      mat-stroked-button
      class="button button-height"
      color="accent"
      (click)="onCreateNew()"
      [attr.aria-label]="isMobile ? (sysText.addNewTemplate | capitalizefirst) : null"
      [matTooltip]="isMobile ? (sysText.addNewTemplate | capitalizefirst) : null"
      [matTooltipShowDelay]="500"
      matTooltipPosition="above">
      <mat-icon>add</mat-icon>
      @if (!isMobile) {
        <span>{{ sysText.addNewTemplate }}</span>
      }
    </button>
  </div>
</div>

<div class="main-content container make-scroll">
  <!-- tabindex -1 so focus can land here after a delete takes its row (and the focused ⋮) away -->
  <table
    #dataTable
    mat-table
    [dataSource]="_et"
    [trackBy]="trackByTemplateId"
    matSort
    id="data-table"
    tabindex="-1">

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.name | titlecase }}</span>
      </th>
      <td mat-cell *matCellDef="let et" [ngClass]="{ smaller: isMobile }">
        <div class="chip-container">
          <a class="link" [routerLink]="'/' + routes.EMAIL_TEMPLATES + '/' + caseCommunicationRoutes.TEMPLATE + '/' + et.id">
            {{ et.name }}
          </a>
        </div>
      </td>
    </ng-container>

    <!-- EmailType Column -->
    <ng-container matColumnDef="emailType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.emailType | titlecase }}</span>
      </th>
      <td mat-cell *matCellDef="let et" [ngClass]="{ smaller: isMobile }">
        <span>{{ et.emailType.description }}</span>
      </td>
    </ng-container>

    <!-- Owner Column -->
    <ng-container matColumnDef="ownerEmployer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.owner | titlecase }}</span>
      </th>
      <td mat-cell *matCellDef="let et" [ngClass]="{ smaller: isMobile }">
        <div class="chip-container">
          @if (et.isSystem) {
            <span class="text-nowrap">
              {{ "-- " + sysText.system + " --" }}
            </span>
          }
          @if (et.isStock) {
            <span class="text-nowrap">
              {{ "-- " + sysText.stock + " --" }}
            </span>
          }
          @if (!et.isSystem && !et.isStock) {
            <a
              class="link" [routerLink]="'/' + routes.EMPLOYER_PROFILE + '/' + et.ownerEmployer.id">
              {{ et.ownerEmployer.employerName }}
            </a>
          }
          @if (et.isOwner) {
            <app-status-chip
              [icon]="'stars'"
              [ngStyle]="chipStyles.successBg"
              [tooltip]="sysText.templateOwner | titlecase"
              [removeMargin]="true">
            </app-status-chip>
          }
        </div>
      </td>
    </ng-container>

    <!-- Allow Use Column -->
    <ng-container matColumnDef="allowUse">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.allowUse | titlecase }}</span>
      </th>
      <td mat-cell *matCellDef="let et" [ngClass]="{ smaller: isMobile }">
        <span class="chip-container">
          <app-status-icon [isEnabled]="et.allowUse"></app-status-icon>
          {{et.allowUse ? (sysText.enabled | titlecase) : (sysText.disabled | titlecase)}}
        </span>
      </td>
    </ng-container>

    <!-- Assigned to My Employer Column -->
    <ng-container matColumnDef="assignedToEmployer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.assignedToMyEmployer }}</span>
      </th>
      <td mat-cell *matCellDef="let et" [ngClass]="{ smaller: isMobile }">
        @if (et.canAssignMyEmployer) {
          <span class="chip-container" >
            <app-status-icon [isEnabled]="et.assignedToEmployer"></app-status-icon>
            {{et.assignedToEmployer ? (sysText.assigned | titlecase) : (sysText.unassigned | titlecase)}}
          </span>
        }
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actionMenu" stickyEnd>
      <th mat-header-cell
        *matHeaderCellDef>
      </th>
      <td mat-cell
        *matCellDef="let et"
        class="cell-align-right action-cell"
        [ngClass]="{ smaller: isMobile }">
        <!-- the ⋮ stays while its action runs, so it keeps focus: showProgress lays the spinner over its icon,
        disabledInteractive keeps it focusable, and the menu won't open while it's aria-disabled -->
        @let submitting = isSubmittingIds.includes(et.id);
        <button
          mat-icon-button
          class="menu-button"
          [matMenuTriggerFor]="menu"
          [disabled]="submitting"
          disabledInteractive
          [showProgress]="submitting"
          [attr.aria-label]="submitting ? sysText.submitting_ariaLabel : sysText.emailTemplateActions_ariaLabel">
          <mat-icon>more_vert</mat-icon>
          <mat-spinner progressIndicator diameter="25" color="accent"></mat-spinner>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item class="grey1" (click)="viewTemplate(et.id)">
            <mat-icon>search</mat-icon>
            <span>{{ sysText.view | capitalizefirst }}</span>
          </button>
          @if (et.canDuplicate) {
            <button mat-menu-item class="grey1" (click)="duplicateTemplate(et)">
              <mat-icon>library_add</mat-icon>
              <span>{{ sysText.duplicate }}</span>
            </button>
          }
          @if (et.canDelete) {
            <button mat-menu-item class="grey1" (click)="onDelete(et)">
              <mat-icon>delete</mat-icon>
              <span>{{ sysText.delete }}</span>
            </button>
          }
          @if (et.canAssignMyEmployer) {
            @if (!et.assignedToEmployer ) {
              <button mat-menu-item class="grey1" (click)="onAssignMyEmployer(et.id)">
                <mat-icon>check</mat-icon>
                <span>{{ sysText.assignEmployer }}</span>
              </button>
            } @else {
              <button mat-menu-item class="grey1" (click)="onUnassignMyEmployer(et.id)">
                <mat-icon>close</mat-icon>
                <span>{{ sysText.unassignEmployer }}</span>
              </button>
            }
          }
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns">
    </tr>
  </table>
</div>

<mat-paginator
  color="accent"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="changePage($event)"
  [showFirstLastButtons]="pageSizeOptions.length > 1">
</mat-paginator>